import { Building2, History, Settings, ShieldCheck, UserRound, UsersRound } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

export const storesTour = defineTour({
  id: 'org.stores',
  version: 1,
  group: 'team',
  route: '/_authed/_active/org/stores/',
  scope: 'org',
  icon: Building2,
  steps: [
    {
      id: 'stores',
      kind: 'explain',
      variants: [{ target: 'org.stores.card' }, { target: 'org.stores.empty', copy: 'empty' }],
    },
    { id: 'open', kind: 'explain', target: 'org.stores.open', optional: true },
    { id: 'settings', kind: 'explain', target: 'org.stores.settings', optional: true },
    { id: 'new', kind: 'explain', target: 'org.stores.new', requires: 'stores.write' },
  ],
  related: ['settings.hub', 'org.team'],
});

export const teamTour = defineTour({
  id: 'org.team',
  version: 2,
  group: 'team',
  route: '/_authed/_active/org/team',
  scope: 'org',
  requires: 'staff.read',
  icon: UsersRound,
  steps: [
    { id: 'table', kind: 'explain', target: 'org.team.table' },
    {
      id: 'row-actions',
      kind: 'explain',
      target: 'org.team.row-actions',
      requires: 'staff.manage',
      optional: true,
    },
    {
      id: 'custom-access',
      kind: 'explain',
      target: 'org.team.custom-access',
      optional: true,
    },
    { id: 'roles-link', kind: 'explain', target: 'org.team.roles-link' },
    { id: 'invite', kind: 'action', target: 'org.team.invite', requires: 'staff.manage' },
  ],
  related: ['org.roles', 'org.activity'],
});

export const rolesTour = defineTour({
  id: 'org.roles',
  version: 1,
  group: 'team',
  route: '/_authed/_active/org/roles',
  scope: 'org',
  requires: 'staff.read',
  icon: ShieldCheck,
  steps: [
    { id: 'table', kind: 'explain', target: 'org.roles.table' },
    { id: 'system-hint', kind: 'explain', target: 'org.roles.system-hint' },
    { id: 'row-menu', kind: 'explain', target: 'org.roles.row-menu', requires: 'staff.manage' },
    { id: 'new', kind: 'explain', target: 'org.roles.new', requires: 'staff.manage' },
  ],
  related: ['org.team'],
});

export const activityTour = defineTour({
  id: 'org.activity',
  version: 1,
  group: 'team',
  route: '/_authed/_active/org/activity',
  scope: 'org',
  requires: 'audit.read',
  icon: History,
  steps: [
    {
      id: 'changes',
      kind: 'explain',
      variants: [{ target: 'org.activity.table' }, { target: 'org.activity.empty', copy: 'empty' }],
    },
    { id: 'filters', kind: 'explain', target: 'org.activity.filters' },
    {
      id: 'load-more',
      kind: 'explain',
      target: 'org.activity.load-more',
      optional: true,
      waitMs: 1000,
    },
  ],
  related: ['org.team'],
});

export const organizationSettingsTour = defineTour({
  id: 'org.settings',
  version: 1,
  group: 'team',
  route: '/_authed/_active/org/settings',
  scope: 'org',
  requires: 'settings.read',
  icon: Settings,
  steps: [
    { id: 'profile', kind: 'explain', target: 'org.settings.profile', requires: 'org.read' },
    { id: 'require-2fa', kind: 'explain', target: 'org.settings.require-2fa' },
    { id: 'weight-unit', kind: 'explain', target: 'org.settings.weight-unit' },
  ],
  related: ['account.security', 'org.team'],
});

export const accountTour = defineTour({
  id: 'account.profile',
  version: 1,
  group: 'team',
  route: '/_authed/_active/account/',
  scope: 'org',
  icon: UserRound,
  steps: [
    { id: 'profile', kind: 'explain', target: 'account.profile' },
    { id: 'email', kind: 'explain', target: 'account.email' },
    { id: 'password', kind: 'explain', target: 'account.password' },
    { id: 'sessions', kind: 'explain', target: 'account.sessions' },
    { id: 'security-link', kind: 'explain', target: 'account.security-link' },
  ],
  related: ['account.security'],
});

export const securityTour = defineTour({
  id: 'account.security',
  version: 1,
  group: 'team',
  route: '/_authed/_active/account/security',
  scope: 'org',
  icon: ShieldCheck,
  steps: [
    { id: 'two-factor', kind: 'explain', target: 'account.security.two-factor' },
    { id: 'setup', kind: 'explain', target: 'account.security.setup', optional: true },
    { id: 'regenerate', kind: 'explain', target: 'account.security.regenerate', optional: true },
  ],
  related: ['account.profile', 'org.settings'],
});
